export default function TipoResidencia(state = {}, action) {
  switch (action.type) {
    case "SELECT_ITEM": {
      return {
        selected: action.selected,
      };
    }
    default:
      return state;
  }
}
